import { createSelector } from 'reselect';

const selectglobalDBNPMappins = (state: any) => state.globalDBNPMappings;


export const selectglobalDBNPMappinCurrentItem = createSelector([selectglobalDBNPMappins], (globalDBNPMappings) => globalDBNPMappings.current);

export const selectglobalDBNPMappinListItems = createSelector([selectglobalDBNPMappins], (globalDBNPMappings) => globalDBNPMappings.list);

export const selectglobalDBNPMappinItemById = (itemId: any) =>
    createSelector(selectglobalDBNPMappinListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectglobalDBNPMappinQueryItems = createSelector([selectglobalDBNPMappins], (globalDBNPMappings) => globalDBNPMappings.query);

export const selectglobalDBNPMappinCreatedItem = createSelector([selectglobalDBNPMappins], (globalDBNPMappings) => globalDBNPMappings.create);

export const selectglobalDBNPMappinUpdatedItem = createSelector([selectglobalDBNPMappins], (globalDBNPMappings) => globalDBNPMappings.update);

export const selectglobalDBNPMappinReadItem = createSelector([selectglobalDBNPMappins], (globalDBNPMappings) => globalDBNPMappings.read);

export const selectglobalDBNPMappinDeletedItem = createSelector([selectglobalDBNPMappins], (globalDBNPMappings) => globalDBNPMappings.delete);

export const selectglobalDBNPMappinSearchedItems = createSelector([selectglobalDBNPMappins], (globalDBNPMappings) => globalDBNPMappings.search);

export const selectglobalDBNPMappinItemsCount = createSelector([selectglobalDBNPMappins], (globalDBNPMappings) => globalDBNPMappings.count);

export const selectglobalDBNPMappinItemsFilter = createSelector([selectglobalDBNPMappins], (globalDBNPMappings) => globalDBNPMappings.filter);